import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const AdministerMedsUI = (props: UIProperties<AdministerMedsUIConfig>) => {
	const [isAdministerEnabled, setIsAdministerEnabled] = useState(false);
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '800px',
				height: '640px'
			}}>
				<img style={{
					width: '100%',
					height: '70px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '733px',
					height: '65px',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '25pt',
						textAlign: 'center',
						position: 'relative',
						top: '13px'
					}} className="title-font" tabIndex={0} id='administer-meds-header'>Administer Medications</p>
				</div>
				<GeneralButton parameters= {{
					top: '0',
					left: '729px',
					width: '90px',
					srcIdle: "./assets/images/general/buttons/button_close_window_main.png",
					srcHighlight: "./assets/images/general/buttons/button_close_window_down.png",
					srcDisabled: null,
					highlightOnHover: false,
					ariaLbl: 'Close',
					onClicked: () => {
						props.parameters.onCloseClicked();
					}
				}}/>
				<div style={{
					width: '100%',
					height: '570px',
					position: 'absolute',
					top: '70px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>
					<img style={{
						width: '100px',
						position: 'absolute',
						top: '80px',
						left: '100px'
					}} src={props.parameters.personIconImage}/>

					<div style={{
						position: 'absolute',
						top: '101px',
						left: '263px',
						width: '422px',
						height: '65px',
					}}>
						<p style={{
							margin: '0px',
							fontSize: '15pt',
							textAlign: 'center',
							position: 'relative',
							top: '13px'
						}} className="title-font" tabIndex={0}>Which drug class do you want for the patient?</p>
						{/* Blue bar removed as per Beta feedback from SMEs */}
					</div>
					<CustomAdministerMedsButton 
						position={{
							type: 'absolute',
							left: '360px',
							top: '200px'
						}}
						id={!isAdministerEnabled ? 'administer-meds-done' : ''}
						text={props.parameters.drugText}
						// id={!isAdministerEnabled ? '' : 'administer-meds-done'}
						onClicked={() => {
							setIsAdministerEnabled(true);
						}}
						 />
					<GeneralButtonWithText parameters= {{
						text: 'Administer',
						top: '420px',
						left: '410px',
						width: '130px',
						id: isAdministerEnabled ? 'administer-meds-done' : '',
						ariaLbl: 'administer',
						isDisabled: !isAdministerEnabled,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
						},
						customButtonStyle : {
						},
						customTextStyle: {
							fontSize: '12pt'
						},
						onClicked: () => {
							props.parameters.onAdministerClicked();
						}
					}}/>
					
				</div>
				
			</div>
		</div>
	);

};

const CustomAdministerMedsButton = (props: CustomAdministerMedsButtonConfig) => {
	const [isClicked, setIsClicked] = useState(false);
	return (
		<div style={{//
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: '234px',
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					text: '',
					top: '0px',
					ariaLbl: props.text,
					id: props.id,
					left: '0px',
					isDisabled: false,
					width: '170px',
					srcIdle: './assets/images/general/buttons/button_side_large.png',
					srcHighlight: null,
					srcDisabled: './assets/images/general/buttons/button_side_large_disabled.png',
					customMainStyle: {
						// position: 'relative',
						// width: props.isFlipped ? '99px' : '129px',
						// transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
					},
					onClicked: () => {
						setIsClicked(true);
						if(props.onClicked) {
							props.onClicked();
						}
					}
				}}/>
				
				<div style={{
					position: 'relative',
					height: '30px',
					pointerEvents: 'none',
					width: '75%',
					left: '12px',
					top: '47px'
				}}>
					<div style={{
						position: 'relative',
						top: '50%',
						transform: 'translate(0, -50%)'
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '16pt',
							fontWeight: 'normal'
						}}>{props.text}</p>
					</div>
					
				</div>

				<img style={{
					position: 'absolute',
					top: 0,
					right: '-59px',
					width: '89px',
					pointerEvents: 'none'
				}} src={"./assets/images/general/buttons/" + (isClicked ? "bar_modal_down_checked" : "bar_modal_down") + ".png"} />
			</div>
		</div>
	);

};

interface CustomAdministerMedsButtonConfig {
	text: string;
	id?: string;
	position: CustomAdministerMedsButtonPosition;
	onClicked?: () => void;
}

interface CustomAdministerMedsButtonPosition {
	type?: any;
	left: string;
	top: string;
}

export interface AdministerMedsUIConfig extends BaseConfig{
	personIconImage: string;
	drugText: string;
	onAdministerClicked: () => void;
	onCloseClicked: () => void;
}

export default AdministerMedsUI;